export default __webpack_public_path__ + "static/media/News & Announcements.3bfdfbcb.svg";